import { Controller } from '@hotwired/stimulus'

export default class ProjectLiveCollectController extends Controller {
  static values = {
    projectId: Number,
    reloadWhenClosed: { type: Boolean, default: false },
  };

  connect() {
    this.channelSubscription = App.cable.subscriptions.create(
      {
        channel: 'ProjectLiveCollectChannel',
        project_id: this.projectIdValue,
      },
      {
        received: (data) => this.#applyBroadcast(data),
      }
    );
  }

  disconnect() {
    if (this.channelSubscription) {
      this.channelSubscription.unsubscribe();
      this.channelSubscription = null;
    }
  }

  #applyBroadcast(data) {
    if (data['project_closed'] === true) {
      const isNewDesignInvestmentModalShown = document.getElementById('investmentModal')?.classList?.contains('show');
      const isCollectOverModalShown = document.getElementById('collectOverModal')?.classList?.contains('show');

      if (!isNewDesignInvestmentModalShown && !isCollectOverModalShown && this.reloadWhenClosedValue) {
        window.location.reload();
      }
      return;
    }

    document.querySelectorAll('.js-collected-amount').forEach((el) => {
      el.innerText = data['collected_amount'];
    });

    document.querySelectorAll('.js-subscribers-count').forEach((el) => {
      el.innerText = data['subscribers_count'];
    });

    document.querySelectorAll('.js-subscribers-count-wording').forEach((el) => {
      el.innerText = data['subscribers_count_investor_wording'];
    });

    document.querySelectorAll('.js-subscribers-count-invest-wording').forEach((el) => {
      el.innerText = data['subscribers_count_invest_wording'];
    });

    document.querySelectorAll('.js-bar').forEach((el) => {
      el.style.width = data['percent_collected'] + '%';
    });

    document.querySelectorAll('.js-percent-collected').forEach((el) => {
      el.innerText = parseInt(data['percent_collected'], 10) + '%';
    });
  }
}
